// extracted by mini-css-extract-plugin
export default {"innerWrapper":"jt-z","tooltipWrapper":"kt-z","icon":"lt-z","tooltip":"mt-z","content":"nt-z"};